import { combineReducers, AnyAction } from "redux";

const initState = {};
const nullReducer = (state: {} = initState, _: AnyAction) => state;

export const rootReducer = combineReducers({
  nullReducer
});
